const nakiHardwareFamily = {
    venice6: 0,
    veniceX: 1,
    pulse: 2,
    mobileApp: 3,
    embeddedApp: 4,
};

export default nakiHardwareFamily;
